const QUERIES = {
  AUDIO_LANGUAGES: 'audio-languages',
  USERS_LIST: 'videos-list',
  MRR_LIST: 'mrr-list',
  LABELS: 'labels',
  COLLECTIONS_LIST: 'collections-list',
  SUBSCRIBERS_LIST: 'subscribers-list',
  SUBSCRIBERS_LIST_ALL: 'subscribers-list-all',
  VIDEO_COLLECTIONS: 'video-collections',
  COLLECTIONS_TYPES: 'collections-types',
  COLLECTIONS_CATEGORIES: 'collections-categories',
  CONTENT_AGE_CATEGORIES: 'content-age-categories',
  CONTENT_CATEGORIES: 'content-categories',
  CONTENT_CATEGORY: 'content-category',
  TAGS_LIST: 'tags-list',
  TAG: 'tag',
  SUBTAGS_LIST: 'subtags-list',
  LANGUAGES: 'languages',
  VIDEO_TAGS: 'video-tags',
  REGION: 'region',
  HOME_BUTTON: 'home-button',
  HOME_BUTTON_LIST: 'home-button-list',
  HOME_BUTTON_REGION_LIST: 'home-button-region-list',
  REGION_LIST: 'region-list',
  TRANSCODER_LIST: 'transcoder-list',
  TOP_COLLECTION_LIST: 'top-collection-list',
  TOP_COLLECTION_REGION_LIST: 'top-collection-region-list',
  TOP_COLLECTION: 'top-collection',
  REPORT: 'report',
  COLLECTION_HOME_BUTTONS_LIST: 'collection-home-buttons-list',
  SUMMARY_VIEWERSHIP: 'summary-viewership',
  OVERVIEW_VIEWERSHIP: 'overview-viewership',
  OVERVIEW_VIEWERSHIP_EXPORT: 'overview-viewership-export',
  LICENSOR_REV_SHARES: 'licensor-rev-shares',
  VIDEOS_LIST: 'videos-list',
  DYNAMIC_BANNER_REGION_LIST: 'dynamic-banner-region-list',
};

export { QUERIES };
